"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = insertInArrayIf;

// @ts-check

/**
 * insert at index if conditional is met
 * const arr = [
 *  ...insertInArrayIf(boolean, { key: prop }),
 *  { key: prop },
 * ];
 *
 * @function insertInArrayIf
 * @param {string}  condition - boolean evaluation
 * @param {object[]} elements - the elements being added to the array
 * @returns {object[]}
 */
function insertInArrayIf(condition) {
  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  return condition ? elements : [];
}